'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

module.exports = assign({}, ServiceClientBase.prototype, {
    getPaymentMethods: function getPaymentMethods(params) {
        var reqData = {
            "token": params.token,
            "deviceId": params.deviceId
        };

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().paymentMethodGet, qs, reqData);
    },
    deletePaymentMethod: function deletePaymentMethod(params) {
        var reqData = {
            "token": params.token,
            "deviceId": params.deviceId
        };

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().paymentMethodDelete, qs, reqData);
    },
    transferGiftCardBalance: function transferGiftCardBalance(params) {
        var reqData = {
            "token": params.token,
            "deviceId": params.deviceId,
            "paymentNumber": params.paymentNumber,
            "paymentSecurityCode": params.paymentSecurityCode
        };

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().balanceTransfer, qs, reqData);
    },
    getDigitalAccountBalance: function getDigitalAccountBalance(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().balanceCombined, qs, params);
    },
    getRecentTransactions: function getRecentTransactions(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().accountTransactions, qs, params);
    },
    loadFundsFromSavedCard: function loadFundsFromSavedCard(params) {
        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().orderingLoadMobileAccount, qs, params);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/paymentServiceClient.js
// module id = 770
// module chunks = 0